export default __webpack_public_path__ + "static/mini-camioneta-2eebfc784336de89b96b73bd87a61cc0.png";